export default __webpack_public_path__ + "static/media/property_977.952ec95e.png";